export const calculateNewOptions = (fullList, currentList, count)=>{
  return fullList.slice(0, (currentList.length + count));
}